import ContaGerencialClassificacaoModel from "../../models/financeiro/contaGerencialClassificacaoModel";

import { IService } from "./../base/iService";

export default class ContaGerencialClassificacaoService extends IService<ContaGerencialClassificacaoModel> {
    constructor() {
        super("ContaGerencialClassificacao");
    }
}